import { dayjs } from '@lifedot/utils'
import { useEffect, useState } from 'react'

export const useIsAfter20250602 = () => {
  const [isAfter20250602, setIsAfter20250602] = useState(false)

  useEffect(() => {
    const today = dayjs()
    if (today.isSameOrAfter('2025-06-02 00:00:00')) setIsAfter20250602(true)
  }, [])
  return isAfter20250602
}
